import { Injectable } from '@angular/core';

import { ISendSMSEditor } from '../node-editors/send-sms-editor/send-sms-editor.component';
import { CompositeNodeConverter, INodeAndLink } from './CompositeNodeConverter';
import { InvalidWorkflowNodeDataError } from './InvalidWorkflowNodeDataError';
import { IProcessConnection, IProcessNodeSetVariable, IProcessNodeSubprocess, IProcessNodeSwitch } from '../../../models/process';
import dataConstants from '../../../data/constants';
import { IWorkflow } from '../../../models/workflow';
import { CONTEXT_VAR_NAME } from '../../../message/message-utils.service';
import { get } from 'lodash';
import { Stringify } from '../../../object/field-formula-side-sheet/field-formula-side-sheet/formula';
import { createConnection, createSetVarNode, createSubProcessNode, createSwitchNode } from './utils/create-node-utils';
import { retrieveFileLocationProcessTips } from '../node-editors/shared/file-location/file-location-types';

@Injectable({
  providedIn: 'root'
})
export class SendSmsConverterService extends CompositeNodeConverter {
  constructor() {
    super();
  }

  convert(nodeData: ISendSMSEditor, workflow: IWorkflow): INodeAndLink {
    if (!this.isValid(nodeData)) {
      throw new InvalidWorkflowNodeDataError(`Please correct invalid data on send SMS node`, nodeData);
    }

    const vars = {
      'Outbound source tip': Stringify({ name: 'ARRAY', args: [nodeData.fields.outboundSource.$tip] }),
      [CONTEXT_VAR_NAME]: get(nodeData.fields.outboundSource, 'contextFormula', 'ARRAY()'),
    };

    const setVarStatusNode = createSetVarNode(vars, nodeData.tip);
    const additionalVarKeys: string[] = [
      ...workflow.inputs.map(input => input.key),
      ...workflow.actors.map(actor => actor.key),
      ...workflow.variables.map(variable => variable.key)
    ];

    const subprocessNode = createSubProcessNode(
      'eim/process/message/send-sms',
      ['Outbound source tip', CONTEXT_VAR_NAME, ...additionalVarKeys],
      60000
    );

    const doneConnectionForSetVarNode = createConnection('done', subprocessNode);
    setVarStatusNode.connections.push(doneConnectionForSetVarNode);

    const switchStatusNode = createSwitchNode({ name: 'VAR', args: ['Status'] }, undefined, undefined, ['Sent', 'Failed']);

    const doneConnectionForSubprocessNode = createConnection('done', switchStatusNode);
    subprocessNode.connections.push(doneConnectionForSubprocessNode);

    const nodesAndLink: INodeAndLink = {
      nodes: [
        setVarStatusNode,
        subprocessNode,
        switchStatusNode
      ],
      links: [
        doneConnectionForSetVarNode,
        doneConnectionForSubprocessNode
      ]
    };
    this.populateOutgoingLinks(nodeData).forEach(link => {
      switchStatusNode.connections.push(link);
      nodesAndLink.links.push(link);
    });

    return nodesAndLink;
  }

  private isValid(nodeData: ISendSMSEditor): boolean {
    return !!nodeData.fields.outboundSource.$tip;
  }
}
